const OSS_IMAGE_HOST = 'hexapus.oss-us-west-1.aliyuncs.com';
const OSS_SIGNED_URL_PARAMS = [
  'OSSAccessKeyId',
  'Signature',
  'Expires',
  'security-token',
];

export type OssImageResizeMode = 'lfit' | 'fill';

/**
 * 为公开的商城 OSS 位图生成下载时缩放 URL。
 *
 * 不修改非本商城 OSS、SVG、已带处理参数或签名 URL，避免影响第三方资源和鉴权。
 */
export function getOssImageUrl(
  url: string,
  {
    width,
    height,
    mode = 'lfit',
  }: {
    width?: number;
    height?: number;
    mode?: OssImageResizeMode;
  },
) {
  if (!url || (!width && !height)) return url;

  try {
    const imageUrl = new URL(url);
    const isSigned = OSS_SIGNED_URL_PARAMS.some((param) =>
      imageUrl.searchParams.has(param),
    );
    const isSvg = imageUrl.pathname.toLowerCase().endsWith('.svg');

    if (
      imageUrl.hostname !== OSS_IMAGE_HOST ||
      isSigned ||
      isSvg ||
      imageUrl.searchParams.has('x-oss-process')
    ) {
      return url;
    }

    const process = [
      'image/resize',
      `m_${mode}`,
      ...(width ? [`w_${Math.ceil(width)}`] : []),
      ...(height ? [`h_${Math.ceil(height)}`] : []),
    ].join(',');
    imageUrl.searchParams.set('x-oss-process', process);
    return imageUrl.toString();
  } catch {
    return url;
  }
}
